import { render, staticRenderFns } from "./StepBrandColorSelection.vue?vue&type=template&id=e3863388&"
import script from "./StepBrandColorSelection.vue?vue&type=script&lang=js&"
export * from "./StepBrandColorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports